import React from 'react'
import { renderPreview } from '../../../../SectionElements/plugins/utils'

const PreviewAttachment = ({version_content}) => {
  const { short_description, attachments } = version_content
  
  // Parse attachments if they're a string
  let attachmentList = []
  if (typeof attachments === "string") {
    try {
      attachmentList = JSON.parse(attachments)
    } catch (e) {
      console.error('❌ Error parsing attachments:', e)
      attachmentList = []
    }
  } else if (Array.isArray(attachments)) {
    attachmentList = attachments
  } else {
  }
  
  // Use attachment_label if available, otherwise construct it
  const attachmentLabel = version_content.attachment_label || version_content.pageTitle || 'Attachment'
  
  return (
    <div>
      <div style={{ padding: '20px' }}>
        {/* Attachment Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '20px',
            paddingBottom: '20px',
            borderBottom: '3px double #e0e0e0',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input type="checkbox" defaultChecked={true} readOnly disabled />
            <h2 style={{ margin: 0, fontSize: '23px' }}>{attachmentLabel}</h2>
          </div>
        </div>

        {/* Attachment Description */}
        {short_description && (
          <p style={{ marginLeft: '5px', whiteSpace: 'pre-wrap' }}>
            {short_description}
          </p>
        )}

        {/* Attachment Previews */}
        {attachmentList && attachmentList.length > 0 ? (
          <div style={{ marginTop: '20px' }}>
            {attachmentList.map((attachment, index) => {
              const attachmentObj = typeof attachment === 'string' ? { attachment } : attachment
              return (
                <div key={index} style={{ marginLeft: '20px', marginBottom: '10px' }}>
                  {renderPreview(attachmentObj)}
                </div>
              )
            })}
          </div>
        ) : (
          <div style={{ marginTop: '20px', marginLeft: '20px', color: '#888' }}>
            <p>No attachments to display</p>
            <p style={{ fontSize: '12px' }}>Debug: attachmentList = {JSON.stringify(attachmentList)}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PreviewAttachment